/**
 * PlatformAdminPage: the platform-administration area shell (P7 wave 3a).
 *
 * Route: `/platform-admin`, gated by `PlatformAdminRoute` (platform-admin
 * only). `platform-admin` is not a reserved slug and resolves in platform
 * mode, so it is safe as a platform route: no tenant can shadow it.
 *
 * This is distinct from the per-ecosystem admin area at `/admin/*` (gated on
 * a per-tenant `EcosystemMembership` role): this area is for the platform
 * super-admin who manages the platform itself.
 *
 * `EcosystemManager`: list / create / edit / archive hosted ecosystems, plus
 * a per-row "Members" button that opens the `EcosystemMembersModal` for
 * managing that ecosystem's per-member roles (admin / member). #262 removed
 * the apex content-editor links this page used to render (`ApexContentLinks`)
 * along with apex CMS support entirely.
 *
 * No inline CSS: Bootstrap utilities / PlatformAdmin.css only.
 */
import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';

import EcosystemManager from './EcosystemManager';
import './PlatformAdmin.css';

export default function PlatformAdminPage() {
    return (
        <>
            <Helmet>
                <title>Platform Administration | RILE Connect</title>
            </Helmet>
            <Container className="py-4">
                <header className="mb-4">
                    <h1 className="text-primary mb-1">
                        Platform Administration
                    </h1>
                    <p className="text-muted mb-0">
                        Manage the ecosystems hosted on the RILE Connect
                        platform.
                    </p>
                </header>

                <EcosystemManager />
            </Container>
        </>
    );
}
